import React, { Component } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { ChevronRight } from 'lucide-react';
import Button from '../Components/Button.js';

class Form extends Component {

    constructor(props) {
        super(props);

        this.initialState = {
            name: '',
            email: '',
            message: '',
            loading: false,
        };

        this.state = { ...this.initialState };
    }

    handlerChange = (event) => {
        const { name, value } = event.target;

        this.setState({
            [name]: value,
        });
    }

    resetFields = () => {
        this.setState(this.initialState);
    }

    setLoading = (loading) => {
        this.setState({ loading: loading });
    }

    validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    validatePhone = (phone) => {
        return /^\(?\d{2}\)?\s?9?\d{1}\.\d{4}-\d{4}$/.test(phone);
    }

    submitForm = () => {
        const { name, email, message } = this.state;
        let errorMessage = '';

        if (!name.trim()) {
            errorMessage += 'Por favor, preencha o campo Nome corretamente.\n';
        }
        
        if (!this.validateEmail(email)) {
            errorMessage += 'Por favor, forneça um endereço de e-mail válido.\n';
        }
      
            
        if (errorMessage) {
            alert(errorMessage);
        } 
        else {
            this.props.handlerSubmit({ name, email, message });
        }
    }

    handlerChangeMask = (event, fieldName) => {
        const { value } = event.target;

        this.setState({
            [fieldName]: value,
        });
    }

    render() {
        const { name, email, message, loading } = this.state;
        return (

            <form className='contact-form'>                
                <div className="input-wrapper">                   
                    <img
                        className="input-icon"
                        src="/images/icons/user.svg"
                        width="18"
                        alt="User"
                    />
                    <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Seu Nome"
                        value={name}
                        onChange={this.handlerChange}
                    />
                </div>   
                <div className="input-wrapper">                   
                    <img
                        className="input-icon-letter"
                        src="/images/icons/letter.svg"
                        width="18"
                        alt="Letter"
                    />
                    <input
                        type="text"
                        name="email"
                        id="email"
                        placeholder='Seu E-mail'
                        value={email}
                        style={{marginTop: '25px'}}
                        onChange={this.handlerChange} 
                    />
                </div>           
                                                              
                <textarea
                    type="text"
                    name="message"
                    id="message"
                    placeholder='Sua Mensagem'
                    value={message}
                    onChange={this.handlerChange}
                    style={{
                        height: '150px',
                        maxHeight: '150px',
                        boxSizing: 'border-box',
                        backgroundColor: '#FAFAFA',
                        marginTop: '25px',
                        marginBottom: '25px'
                    }}
                />
                {loading ? (
                    <div className='spinner-block'>
                        <Spinner animation="border" role="status" variant="primary">
                        </Spinner>
                    </div>
                    
                ) : (
                    // <input style={{ width: '100%', marginTop: '10px' }} type="button" value="Enviar" onClick={this.submitForm} />
                    <Button
                        label="Enviar"
                        variant="primary"
                        size="small"
                        iconRight={<ChevronRight/>}
                        onClick={this.submitForm}                                        
                    /> 
                )}
            </form>

        );
    }
}

export default Form;
